import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { client } from './client';
import 'assets/scss/material-kit-react.scss?v=1.4.0'


export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
);
